import { useAppSelector } from "../store/hooks"
import { DialogsApiEndpointNames, dialogsApi } from "./controllers/dialogs"

// Собираем информацию об аргументах и результатах каждого эндпоинта
type AllEndpointsMap = {
    [K in DialogsApiEndpointNames]: {
        arg: Parameters<typeof dialogsApi.endpoints[K]["select"]>[0]
        result: ReturnType<ReturnType<typeof dialogsApi.endpoints[K]["select"]>>
    }
}

/**
 * Returns the cached data from the specified dialogs API endpoint.
 *
 * @param endpoint - The name of the DialogsApiEndpoint.
 * @param selectArgs - Optional arguments for the selector function.
 * @return The cached data from the DialogsApiEndpoint.
 */
export function useGetDialogApiCachedEndpointData<E extends DialogsApiEndpointNames>(
    endpoint: E,
    selectArgs: AllEndpointsMap[E]["arg"]
): AllEndpointsMap[E]["result"] {
    return useAppSelector(state => {
        // Принудительно говорим, что это селектор конкретного эндпоинта
        const endpointSelect = dialogsApi.endpoints[endpoint].select as (
            arg: AllEndpointsMap[E]["arg"]
        ) => (s: typeof state) => AllEndpointsMap[E]["result"]

        // Принудительно говорим, что это аргументы конкретного эндпоинта
        const selector = endpointSelect(selectArgs as AllEndpointsMap[E]["arg"])
        return selector(state)
    })
}
